import Layout from "../../components/Layout";
import PageHeader from '../PageHeader/PageHeader';
import EnrollForm from "./EnrollForm";
import { useLocation, useNavigate, useHistory } from 'react-router-dom';
import { useEffect, useState, useRef } from "react";
import { GdkModal } from "@gdk/modal";
import '../../styles/Sweeps.css';
import { logDetails } from "../../api/logger-configuration";

const SweepAccountSettings = () => {
    const location = useLocation();
    const [agencyProfile, setAgencyProfile] = useState();
    const [branchProfile, setBranchProfile] = useState();
    const [isBranch, setIsBranch] = useState(false);
    const navigate = useNavigate();
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [errorHeading, setErrorHeading] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const gdkModal = useRef(null);
    const modalIdRef = useRef("cancel-modal");
    const onCancelConfirm = () => {
        setShowConfirmationModal(false);
        redirectToEmaiSettings();
    }
    const handleEmailSettingsLinkClick = () => {
        setShowConfirmationModal(true);
    }

    const redirectToEmaiSettings = () => {
        navigate(-1);
    }

    const handleCancel = () => {
        logDetails("Sweep Account Management: User clicked on Cancel button");
        navigate("/profiles", { state: { showCancelAlert: true, agencyProfile: agencyProfile, enrollSuccess: false } });
    };

    useEffect(() => {
        gdkModal.current = new GdkModal({
            content: "#" + modalIdRef.current,
            hideCloseButton: false,
            onClosed: () => {
                setShowConfirmationModal(false);
            },
        });
    }, []);

    useEffect(() => {
        if (showConfirmationModal === true && gdkModal.current?.show) {
            gdkModal.current.show();
        }
        if (showConfirmationModal === false && gdkModal.current?.hide) {
            gdkModal.current.hide();
        }
    }, [showConfirmationModal]);


    useEffect(() => {
        setAgencyProfile(location.state?.agencyProfile);
        setBranchProfile(location.state?.branchProfile);
        setIsBranch(location.state?.isBranch);
    }, []);

    const handleEnrollFormError = (errorCode) => {
        if (errorCode === 409) {
            setErrorHeading("You've Already Added This Account");
            setErrorMessage("This account is already saved to your profile. To add a new account, please enter different account information.");
            setShowErrorAlert(true);
        } else if (errorCode === 500) {
            setErrorHeading("Something went wrong");
            setErrorMessage("We couldn't save your banking details. You will be redirected to your profile management page to try again.");
            setShowErrorAlert(true);
        }
    }

    return (
        <Layout>
            <PageHeader
                header="Sweep Account Management"
                showBottomBorder={false}
                children={
                    <p>
                        Review and edit information related to your GEICO agency profile and sweep accounts. Some changes can only be made by an administrator or with the National Producer Database.
                    </p>
                }
            />
            <div className="container margin-top sweeps">
                {showErrorAlert && (
                    <div id="alert-high" className="alert" role="alert">
                        <div className="alert--high-importance">
                            <span className="icon-alert" />
                            <ul className="alert-list">
                                <li className="alert-content">
                                    <button aria-label="Close alert" className="icon-close" onClick={() => setShowErrorAlert(false)}></button>
                                    <div className="h4">{errorHeading}</div>
                                    <p>
                                        {errorMessage}
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
                {agencyProfile && (
                    <div>
                        <gds-progress-bar-group>
                            <gds-progress-bar value="100" onClick={handleEmailSettingsLinkClick}>
                                <span className="progress-bar-email-settings" data-testid="email-settings-link">Email Settings</span>
                            </gds-progress-bar>
                            <gds-progress-bar value="50">Sweep Account</gds-progress-bar>
                        </gds-progress-bar-group>
                        <ul className="expandable-form">
                            <li>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4>Sweep Account Settings</h4>
                                    </div>
                                </div>
                                {isBranch ? (
                                    <EnrollForm branchProfile={branchProfile} agencyProfile={agencyProfile} isBranch={isBranch} onCancel={handleCancel} setErrorAlert={handleEnrollFormError} />
                                ) : (
                                    <EnrollForm agencyProfile={agencyProfile} onCancel={handleCancel} setErrorAlert={handleEnrollFormError} />
                                )}

                            </li>
                        </ul>
                    </div>
                )}
            </div>
            <div
                id="cancel-modal"
                className={`modal${showConfirmationModal ? ' show' : ' hide'}`}
            >
                <div className="modal-container" style={{ height: '25rem', width: '30%' }}>
                    <h4 className="modal-headline"> Leave this page? </h4>
                    <div className="modal-content">
                        If you leave this page, all unsaved payment information will be lost.
                    </div>
                    <div className="modal-content">
                        <div className="modal--call-to-action-bar">
                            <button type="button" className="btn btn--secondary btn--full-mobile btn--pull-right" onClick={onCancelConfirm}>
                                <span>Continue</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default SweepAccountSettings;